<template>
  <!-- 设置密码 -->
  <div class="box">
    <div class="content">
      <img class="reg-img" src="../../views/registration/assets/images/register_shezhimima.png" alt="">
      <!--表单开始 -->
      <el-form :model="fromData" ref="fromData" label-width="100px" class="demo-ruleForm" :rules="rules">
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input type="password" v-model.trim="fromData.password" placeholder="请输入6-18位数字或字母组合"></el-input>
        </el-form-item>
        <!-- 确认密码 -->
        <el-form-item prop="confirmPassword">
          <el-input type="password" v-model.trim="fromData.confirmPassword" placeholder="请再次输入密码"></el-input>
        </el-form-item>
        <!-- 按钮 -->
        <el-form-item>
          <!-- <el-button type="primary" class="btn-left" @click="handleBack">上一步</el-button> -->
          <el-button type="primary" class="btn-right" @click="handleRegister">注册</el-button>
        </el-form-item>
      </el-form>
      <!-- 表单结束 -->
    </div>
  </div>
</template>

<script>
// 引入api
import { userRegisterTelephone, userRegisterEmail } from '@/services/loginRegister';
import { createMemberUserOrder } from '@/services/member';
// 引入md5
import md5 from "js-md5";
export default {
  name: "setPassword",
  props: {
    // 控制显示
    stepActive: {
      type: Number,
      required: true
    },
    // 用户验证信息
    info: {
      type: Object,
      default: () => { }
    },
    // 注册类别
    userTest: {
      type: String,
      required: true
    },
  },
  data() {
    // 密码验证
    const testPassword = (rule, value, callback) => {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      if (value === "") {
        callback(new Error("请输入密码"))
      } else if (!reg.test(value)) {
        callback(new Error("请输入6-18位数字和字母组合"))
      } else {
        callback()
      }
    }
    // 确认密码验证
    const testConfirmPassword = (rule, value, callback) => {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (!reg.test(value)) {
        callback(new Error("请输入6-18位数字和字母组合"))
      } else if (this.fromData.password !== value) {
        callback(new Error("两次输入密码不一致"))
      } else {
        callback()
      }
    }
    return {
      // 表单数据
      fromData: {
        password: "",
        confirmPassword: ""
      },
      // 验证规则
      rules: {
        password: [{ validator: testPassword, trigger: 'blur' },],
        confirmPassword: [{ validator: testConfirmPassword, trigger: 'blur' }]
      },
      // 设置显示
      activeNum: this.stepActive,
      queryDate: {
        sourceAppid: '',
      },
    }
  },
  mounted() {
    if (this.$route.query.key !== undefined) {
      this.queryDate = JSON.parse(this.$Base64.decode(this.$route.query.key));
    }else if(typeof SOURCE_APPID !== "undefined"){
      this.queryDate.sourceAppid = SOURCE_APPID;
    }
  },
  methods: {
    // 返回上一页
    handleBack() {
      this.$emit('setStepActive', --this.activeNum)
    },
    getRegisterUserId(response) {
      const data = response && response.data;
      const result = response && response.result;
      if (typeof data === "string" || typeof data === "number") {
        return data;
      }
      if (typeof result === "string" || typeof result === "number") {
        return result;
      }
      return (response && (response.userId || response.uid || response.id))
        || (data && (data.userId || data.uid || data.id))
        || (data && data.user && (data.user.userId || data.user.id))
        || (result && (result.userId || result.uid || result.id))
        || (result && result.user && (result.user.userId || result.user.id))
        || "";
    },
    async createOrderAfterRegister(response) {
      const userId = this.getRegisterUserId(response);
      if (!userId) {
        return;
      }
      // await createMemberUserOrder(userId);
    },
    // 注册
    handleRegister() {
      this.$refs.fromData.validate(async (valid) => {
        if (valid) {
          if (this.userTest === "userPone") { //手机号码注册用户设置密码
            const params = {
              loginPhone: this.info.loginPhone,
              password: md5(this.fromData.confirmPassword),//md5加密
              verificationCode: this.info.VerifyCode,
              sourceAppid: this.queryDate.sourceAppid,
            }
            // 调用手机号注册用户 设置密码接口
            const response = await userRegisterTelephone(params)
            if (response.success) {
              await this.createOrderAfterRegister(response)
              this.$emit('setStepActive', ++this.activeNum)
            }
          } else { //邮箱号码注册用户设置密码
            const params = {
              email: this.info.loginPhone,
              password: md5(this.fromData.confirmPassword),
              verificationCode: this.info.VerifyCode,
              sourceAppid: this.queryDate.sourceAppid,
            }
            // 调用手机号注册用户 设置密码接口
            const response = await userRegisterEmail(params)
            if (response.success) {
              await this.createOrderAfterRegister(response)
              this.$emit('setStepActive', ++this.activeNum)
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../views/registration/assets/images/register_bg3.png")
    no-repeat;
  .content {
    box-sizing: border-box;
    padding: 0 75px;
    position: absolute;
    top: 127px;
    left: 0px;
    width: 460px;
    height: 400px;
    opacity: 1;
    border-radius: 10px;
    text-align: center;
    .reg-img {
      margin-top: 69px;
      width: 151px;
      height: 41px;
    }
    /deep/.el-form {
      margin-top: 37px;
      .el-form-item__content {
        margin-left: 0 !important;
        .el-input__inner {
          height: 46px;
          &::placeholder {
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            opacity: 0.5;
            text-align: center;
          }
        }
      }
      .btn-left {
        width: 140px;
        height: 46px;
        font-size: 16px;
        color: #0078fc;
        background: #ffffff;
        border: 1px solid #0078fc;
        border-radius: 8px;
      }
      .btn-right {
        // width: 140px;
        width: 100%;
        font-size: 16px;
        height: 46px;
        border-radius: 8px;
        background-color: #0078fc;
        &:hover {
          background: #3393fd;
          border-color: #3393fd;
          color: #fff;
        }
        &:active {
          background: #006ce3;
          border-color: #006ce3;
          color: #fff;
        }
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
</style>
